/* eslint-disable import/prefer-default-export */
import { ref } from "vue";
import { defineStore } from "pinia";
import useLocalStorage from "@/composables/storage/useLocalStorage.js";
import filters from "@/composables/store/filters";
import useFormValidation from "@/composables/validations/useFormValidation";
import useGlobalActions from "@/composables/store/globalActions";

const { bindLocalStorage } = useLocalStorage();
const { updateErrorFieldByKey } = useGlobalActions();
const {
  validateCurpField,
  validateCpfField,
  validateSaidField,
  validateCcField,
  validateDniField,
  validateCiField,
  validateTicField,
} = useFormValidation();
const { formHasErrors, getErrorByField } = filters();

const formObject = ref({
  curp: {
    title: "Your Mexican Identity Card",
    label: "Your CURP number *",
    placeholder: "CURP number",
    value: null,
    required: true,
    error: null,
    validator: validateCurpField,
  },
  said: {
    title: "Your South African Identity Card",
    label: "Your SAID number *",
    placeholder: "SAID number",
    value: null,
    required: true,
    error: null,
    validator: validateSaidField,
  },
  cpf: {
    title: "Your Cadastro de Pessoas Físicas (CPF)",
    label: "Your CPF number *",
    placeholder: "CPF number",
    value: null,
    required: true,
    error: null,
    validator: validateCpfField,
  },
  cc: {
    title: "Your Cédula de Ciudadanía (CC)",
    label: "Your CC number *",
    placeholder: "CC number",
    value: null,
    required: true,
    error: null,
    validator: validateCcField,
  },
  dni: {
    title: "Your Documento Nacional de Identidad (DNI)",
    label: "Your DNI number *",
    placeholder: "DNI number",
    value: null,
    required: true,
    error: null,
    validator: validateDniField,
  },
  ci: {
    title: "Your Cédula de identidad (CI)",
    label: "Your CI number *",
    placeholder: "CI number",
    value: null,
    required: true,
    error: null,
    validator: validateCiField,
  },
  tic: {
    title: "Your Thai Identity Card (TIC)",
    label: "Your TIC number *",
    placeholder: "TIC number",
    value: null,
    required: true,
    error: null,
    validator: validateTicField,
  },
});

export const useDlocalIdentityStore = defineStore({
  id: "dlocalIdentityStore",
  state: () => ({
    form: formObject,
  }),
  getters: {
    formHasErrors: (store) => formHasErrors(store),
    getErrorByField: (store) => (field) => getErrorByField(store)(field),
  },
  actions: {
    updateValue(field, val) {
      if (Object.getOwnPropertyDescriptor(this.form[field], "validator")) {
        const { validator } = this.form[field];

        this.form[field].error = validator(field, val);
      }
      this.form[field].value = val;
      bindLocalStorage(this.$id, this.form);
    },

    /**
     * NOTE:
     *  KEY or KEYS in this file is referred to keys of formObject. For example, curp, said etc.
     */

    // Update required and error attributes for all the fields that is not required for the selected PSP
    updateRequiredAndErrorFieldForNotSelectedKeys(selectedField) {
      if (
        !selectedField ||
        !Object.getOwnPropertyDescriptor(this.form, selectedField) ||
        !Object.getOwnPropertyDescriptor(this.form[selectedField], "required")
      ) {
        return;
      }

      const clone = { ...this.form };
      delete clone[selectedField];

      Object.keys(clone).forEach((key) => {
        this.form[key].required = false;
        this.form[key].error = "";
      });
    },

    updateErrorFieldByKey(field, errorMessage) {
      updateErrorFieldByKey(this.form, field, errorMessage);
    },
  },
});
